import { render } from "./Outro.vue?vue&type=template&id=eda75532&scoped=true&ts=true"
import script from "./Outro.vue?vue&type=script&lang=ts"
export * from "./Outro.vue?vue&type=script&lang=ts"

import "./Outro.vue?vue&type=style&index=0&id=eda75532&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eda75532"]])

export default __exports__